import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import graphTracesReducer from './slices/graphTracesSlice';
import { buildingsApi } from './api/buildingsApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    graphTraces: graphTracesReducer,
    [buildingsApi.reducerPath]: buildingsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(buildingsApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 